import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { bodySmall, caption, monoFont } from '@/styles/typography';

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 30px;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 360px;
  max-width: 100%;
`;

export const Mono = styled.span`
  ${monoFont};
  font-size: 13px;
`;

export const SourceTag = styled.span<{ $source: string }>`
  ${caption};
  padding: 4px 12px;
  border-radius: 6px;
  font-weight: 600;
  background: ${({ $source }) => ($source === 'domain' ? COLORS.green[50] : COLORS.grey[200])};
  color: ${({ $source }) => ($source === 'domain' ? COLORS.green[600] : COLORS.grey[700])};
`;

export const DiffTable = styled.table`
  ${bodySmall};
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    text-align: left;
    padding: 6px 8px;
    border-bottom: 1px solid ${COLORS.grey[200]};
    vertical-align: top;
  }

  td:not(:first-child) {
    word-break: break-word;
  }

  th {
    ${caption};
    color: ${COLORS.grey[650]};
    font-weight: 600;
  }
`;
